import { getSafeUrl } from "../utils/helpers.js";
import { useState, useContext, useEffect, useMemo } from "react";

import { Col, Form, Row, Spinner } from "react-bootstrap";
import { InputNumber, Modal, Tooltip, Button } from "antd";
import axios from "axios";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { useUserState } from "../Contexts/UserContext";
import { HouseContext } from "../Contexts/HouseContext";

import UploadImg from "../assets/images/upload.png";
import OwnerPlusSvg from "../assets/images/ownerplus.svg";
import CloseCircleSvg from "../assets/images/close-circle.svg";
import HouseDummyImg from "../assets/images/houseDummy.webp";
import GoogleMapsSelector from "./common/GoogleMapsSelector";
import LocationSelectorMap from "@common/LocationSelectorMap";
import { stateAbbrevToName } from "../data/statesData";

const amenitiesData = [
  "Air conditioner",
  "Internet",
  "Elevator",
  "Stairs",
  "Power backup",
  "Security",
  // "Park",
  "Fire safety",
  "Parking",
  // "Pet Friendly",
];

const utilitiesData = [
  "Electricity",
  "Gas",
  "Water",
  "Heater",
  "Internet",
  "Sewer",
  "Trash",
];

const restrictedWordsRegex =
  /\b(?:one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|thirteen|fourteen|fifteen|sixteen|seventeen|eighteen|nineteen|twenty|thirty|forty|fifty|sixty|seventy|eighty|ninety|hundred|thousand|million|billion|road|rd|drive|dr|street|st|str|near|avenue|ave|boulevard|blvd|lane|ln|court|ct|way|wy|place|pl|circle|cir|square|sq|terrace|ter|parkway|pkway|alley|aly|path|pth|close|cl|crescent|cres|trail|trl|highway|hwy|expressway|expy|freeway|fwy|loop|row|r\s?-?\s?o\s?-?\s?a\s?-?\s?d)\b|\b\d+\b/gi;
const restrictedWordsPatternForHouseDescription =
  /\b(tel|call|road|rd|drive|dr|street|st|str|near|avenue|ave|boulevard|blvd|lane|ln|court|ct|way|wy|place|pl|circle|cir|square|sq|terrace|ter|parkway|pkway|alley|aly|path|pth|close|cl|crescent|cres|trail|trl|highway|hwy|expressway|expy|freeway|fwy|loop|row)\b/gi;
const phonePattern =
  /(\+?\d{1,2}\s?)?(\(\d{3}\)|\d{3})[\s\-\.]?\d{3}[\s\-\.]?\d{4}/g;
const emailPattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g;
const urlPattern = /\b(?:https?|ftp):\/\/\S+\b|\bwww\.\S+/gi;
// Configuration - set your Google Maps API key here
const Maps_API_KEY = import.meta.env.VITE_Maps_API_KEY || "";
const USE_Maps = !!Maps_API_KEY; // Use Google Maps if API key is available

function OwnerAddHouse({ toggleComponentHouse }) {
  const { user } = useUserState();
  const [iSubmitConfirmation, setIsSubmitConfirmation] = useState(false);
  const [showMap, setShowMap] = useState(true);
  const { house, setHouse } = useContext(HouseContext);
  const [securityInsuranceFee, setSecurityInsuranceFee] = useState(null);
  const [inputData, setInputData] = useState({
    propertyName: house?.name ? house?.name : "",
    country: house?.country ? house?.country : "US",
    state: house?.state ? house?.state : "",
    zipCode: house?.zip_code ? house?.zip_code : "",
    monthlyPrice: house?.monthly_price ? parseInt(house?.monthly_price) : "",
    securityPrice:
      house?.security_prices || securityInsuranceFee
        ? parseInt(house?.security_prices)
        : "",
    non_refundable_fee: house?.non_refundable_fee
      ? parseInt(house?.non_refundable_fee)
      : "",
    houseType: house?.house_type ? house?.house_type : "Apartment",
    floorCount: house?.floor ? parseInt(house?.floor) : "",
    bedroomCount: house?.bedroom_no ? parseInt(house?.bedroom_no) : "",
    bathroomCount: house?.bathroom_no ? parseFloat(house?.bathroom_no) : "",
    propertyOption: house?.house_facility
      ? house?.house_facility
      : "Fully Furnished",
    propertyAreaCount: house?.area ? parseInt(house?.area) : "",
    leasePeriodCount: house?.min_lease_period
      ? parseInt(house?.min_lease_period)
      : 1,
    fullAddress: house?.full_address ? house?.full_address.split(";")[0] : "",
    aprt_suite: house?.full_address ? house?.full_address.split(";")[1] : "",
    city: house?.full_address ? house?.full_address.split(";")[2] : "",
    propertyDetail: house?.property_details ? house?.property_details : "",

    propertyUtilityPrice: house?.total_utilities_price,

    isPetAllow: house?.is_pets_allowed,
    utilitiesPriceIncluded: house?.utilities_price_included,
    latitude: house?.latitude || "",
    longitude: house?.longitude || "",
  });
  const [fullAddress, setFullAddress] = useState(inputData?.fullAddress);
  const [utilityPrice, setUtilityPrice] = useState(
    inputData?.propertyUtilityPrice,
  );
  const [inputError, setInputError] = useState(false);
  const [error, setError] = useState(false);
  const [houseImages, setHouseImages] = useState([]);
  const [uploadingImages, setUploadingImages] = useState([]);
  const [houseDocImages, setHouseDocImages] = useState([]);
  
  const [houseAmenities, setHouseAmenities] = useState(
    house?.amenities ? house?.amenities?.split(",") : [],
  );
  const [houseUtility, setHouseUtility] = useState([]);

  const [petAllowed, setPetAllowed] = useState(inputData?.isPetAllow || false);

  const [utilityData, setUtilityData] = useState([]);

  const [isUtilityIncludedPrice, isSetUtilityIncludePrice] = useState(
    inputData?.utilitiesPriceIncluded
      ? inputData?.utilitiesPriceIncluded
      : false,
  );

  const [btnLoader, setBtnLoader] = useState(false);
  const [activeMethod, setActiveMethod] = useState('manual');
  const [csvProperties, setCsvProperties] = useState([]);
  const [editingProperty, setEditingProperty] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [showPropertyEditModal, setShowPropertyEditModal] = useState(false);
  const zipRegex = /^\d{5}(-\d{4})?$/;

  const headersFormData = {
    "Content-Type": "multipart/form-data",
  };

  const headerJson = {
    "Content-Type": "application/json",
    Authorization: user?.token,
  };

  const openImagePathGenerator = () => {
    window.open(
      `/user_dash/${user?.currentRole}/image_path_generator`,
      "_blank",
      "noopener,noreferrer",
    );
  };
   
  const containsRestrictedWords = (text) => {
    return restrictedWordsRegex.test(text);
  };
  const containsRestrictedWordForHouseDescription = (text) => {
    return restrictedWordsPatternForHouseDescription.test(text);
  };

  const makeValidHouseDescription = (description) => {
    description = description
      .replace(restrictedWordsPatternForHouseDescription, "")
      .trim();
    description = description.replace(emailPattern, "").trim();
    description = description.replace(urlPattern, "").trim();
    description = description.replace(/\d+/g, "").trim();
    description = description.replace(/[^a-zA-Z\s,-.]/g, "").trim();
    description = description.replace(/\.\w{2,}(\.\w{2,})?/gi, "").trim();
    description = description
      .replace(/(?:yahoo|gmail|hotmail|outlook|icloud|aol)/gi, "")
      .trim();
    description = description.replace(/\s+/g, " ").trim();
    return description;
  };

  const makeValidHousename = (propertyName) => {
    return propertyName
      .replace(restrictedWordsRegex, "")
      .replace(emailPattern, "")
      .trim() 
      .replace(urlPattern, "")
      .trim()
      .replace(/[^\w\s]/g, "")
      .replace(/(?:yahoo|gmail|hotmail|outlook|icloud|aol|gmail)/gi, "")
      .trim()
      .replace(/\s+/g, " ")
      .trim();
  };

  const handleConfirmForSubmit = () => {
    const propertyName = inputData?.propertyName;

    const isvalidHouseName = containsRestrictedWords(propertyName);
    const isValidHouseDescription = containsRestrictedWordForHouseDescription(
      inputData?.propertyDetail,
    );
    if (isvalidHouseName || isValidHouseDescription) {
      setIsSubmitConfirmation(true);
    } else {
      house ? handleUpdateSubmit() : handleSubmit();
    }
  };

  const handleSubmit = async () => {
    let {
      propertyName,
      country,
      state,
      zipCode,
      monthlyPrice,
      securityPrice,
      houseType,
      floorCount,
      bedroomCount,
      bathroomCount,
      propertyOption,
      propertyAreaCount,
      leasePeriodCount,
      fullAddress,
      aprt_suite,
      city,
      propertyDetail,
      latitude,
      longitude,
      non_refundable_fee,

      // houseUtility,
      // utilityPrice,
    } = inputData;

    propertyName = makeValidHousename(propertyName);
    propertyDetail = makeValidHouseDescription(propertyDetail);

    if (
      houseImages?.length <= 0 ||
      !propertyName ||
      !country ||
      !state ||
      !zipCode ||
      !zipRegex.test(zipCode) ||
      !monthlyPrice ||
      (securityPrice === "" || securityPrice === null || securityPrice === undefined) ||
      !houseType ||
      !floorCount ||
      !bedroomCount ||
      !bathroomCount ||
      !propertyOption ||
      !propertyAreaCount ||
      !leasePeriodCount ||
      !fullAddress ||
      // !aprt_suite ||
      !city ||
      !propertyDetail ||
      !non_refundable_fee ||
      houseDocImages?.length <= 0
      //houseUtility?.length === 0
      // (!isUtilityIncludedPrice && utilityPrice <= 0)
    ) {
      setInputError(true);
      setBtnLoader(false);
    } else {
      try {
        setInputError(false);

        setBtnLoader(true);
        let data = {
          name: propertyName,
          country: country,
          state: state,
          zip_code: zipCode,
          monthly_price: monthlyPrice,
          security_prices: securityPrice,
          non_refundable_fee: non_refundable_fee,
          house_type: houseType,
          floor: floorCount,
          property_details: propertyDetail,
          area: propertyAreaCount,
          bathroom_no: parseFloat(bathroomCount),
          bedroom_no: bedroomCount,
          amenities: houseAmenities?.toString(),
          // facing_side: formData.facing_side,
          house_facility: propertyOption,
          full_address: `${fullAddress};${aprt_suite};${city}`,
          house_images: houseImages?.map((val) => val?.imageUrl),
          house_documents: houseDocImages?.map((val) => val?.imageUrl),
          min_lease_period: leasePeriodCount,
          //utilityName: JSON.stringify(houseUtility),
          utilities: JSON.stringify(utilityData),

          total_utilities_price: utilityPrice,
          utilities_price_included: isUtilityIncludedPrice,
          is_pets_allowed: petAllowed,
          latitude: latitude,
          longitude: longitude,
        };

        console.log("datatest", data);
        const res = await axios.post(
          `${import.meta.env.VITE_APP_BASE_URL}/api/house/create`,
          data,
          { headers: headerJson },
        );
        setBtnLoader(false);
        if (res) {
          toggleComponentHouse();
        }
      } catch (err) {
        setBtnLoader(false);
        alert("Error while adding property: " + err?.message);
        console.log("Error while adding property", err?.message);
      }
    }
  };

  const handleUpdateSubmit = async () => {
    let {
      propertyName,
      country,
      state,
      zipCode,
      monthlyPrice,
      securityPrice,
      non_refundable_fee,
      houseType,
      floorCount,
      bedroomCount,
      bathroomCount,
      propertyOption,
      propertyAreaCount,
      leasePeriodCount,
      fullAddress,
      aprt_suite,
      city,
      propertyDetail,
      propertyUtilityPrice,
      isPetAllow,
      utilitiesPriceIncluded,
      latitude,
      longitude,
    } = inputData;
    propertyName = makeValidHousename(propertyName);
    propertyDetail = makeValidHouseDescription(propertyDetail);

    if (
      houseImages?.length <= 0 ||
      !propertyName ||
      !country ||
      !state ||
      !zipCode ||
      !zipRegex.test(zipCode) ||
      !monthlyPrice ||
      (securityPrice === "" || securityPrice === null || securityPrice === undefined) ||
      !houseType ||
      !floorCount ||
      !bedroomCount ||
      !bathroomCount ||
      !propertyOption ||
      !propertyAreaCount ||
      !leasePeriodCount ||
      !fullAddress ||
      // !aprt_suite ||
      !city ||
      !propertyDetail ||
      !non_refundable_fee ||
      houseDocImages?.length <= 0
    ) {
      setInputError(true);
    } else {
      setInputError(false);
      setBtnLoader(true);
      let data = {
        name: propertyName,
        country: country,
        state: state,
        zip_code: zipCode,
        monthly_price: monthlyPrice,
        security_prices: securityPrice,
        non_refundable_fee: non_refundable_fee,
        house_type: houseType,
        floor: floorCount,
        property_details: propertyDetail,
        area: propertyAreaCount,
        bathroom_no: parseFloat(bathroomCount),
        bedroom_no: bedroomCount,
        amenities: houseAmenities?.toString(),
        //houseUtility:utilityData,
        // facing_side: formData.facing_side,
        house_facility: propertyOption,
        full_address: `${fullAddress};${aprt_suite};${city}`,
        house_images: houseImages,
        house_documents: houseDocImages,
        min_lease_period: leasePeriodCount,

        total_utilities_price: utilityPrice,
        utilities_price_included: isUtilityIncludedPrice,
        is_pets_allowed: petAllowed,
        latitude: latitude,
        longitude: longitude,
      };
      try {
        const res = await axios.put(
          `${import.meta.env.VITE_APP_BASE_URL}/api/house/update/${house?.id}`,
          data,
          { headers: headerJson },
        );
        setHouse(null);
        setBtnLoader(false);
        if (res) {
          toggleComponentHouse();
        }
      } catch (err) {
        setBtnLoader(false);
        console.log("Error while updating house", err?.message);
      }
    }
  };

  const handleHouseImages = async (e) => {
    try {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      const newUploads = files.map(file => ({
        id: Math.random().toString(36).substring(7),
        file,
        progress: 0,
        error: null
      }));
      setUploadingImages(prev => [...prev, ...newUploads]);

      const uploadPromises = newUploads.map(async (uploadItem) => {
        let formData = new FormData();
        formData.append("image", uploadItem.file);
        try {
          let res = await axios.post(
            `${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`,
            formData,
            { 
              headers: headersFormData,
              onUploadProgress: (progressEvent) => {
                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setUploadingImages(prev => prev.map(item => 
                  item.id === uploadItem.id ? { ...item, progress: percentCompleted } : item
                ));
              }
            }
          );
          
          setUploadingImages(prev => prev.filter(item => item.id !== uploadItem.id));
          return { ...res?.data?.data, localPreview: URL.createObjectURL(uploadItem.file) };
        } catch (err) {
          console.log("Error while adding house image", err?.message);
          setUploadingImages(prev => prev.map(item => 
            item.id === uploadItem.id ? { ...item, error: "Failed" } : item
          ));
          return null;
        }
      });

      const results = await Promise.all(uploadPromises);
      const successfulUploads = results.filter(Boolean);
      
      setHouseImages(prev => [...prev, ...successfulUploads]);
    } catch (err) {
      console.log("Error while adding house images", err?.message);
    }
  };

  const removeImage = (index) => {
    let url_data = [...houseImages];
    url_data?.splice(index, 1);
    setHouseImages(url_data);
  };

  const handleHouseDocs = async (e) => {
    try {
      const file = e.target.files[0];
      let formData = new FormData();
      formData.append("image", file);
      let res = await axios.post(
        `${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`,
        formData,
        { headers: headersFormData },
      );
      setHouseDocImages([...houseDocImages, res?.data?.data]);
    } catch (err) {
      console.log("Error while adding house property papers", err?.message);
    }
  };

  const removeDoc = (index) => {
    let url_data = [...houseDocImages];
    url_data?.splice(index, 1);
    setHouseDocImages(url_data);
  };

  const handleCheckboxChange = (amenity) => {
    const index = houseAmenities?.indexOf(amenity);
    if (index === -1) {
      setHouseAmenities([...houseAmenities, amenity]);
    } else {
      const updatedAmenities = [...houseAmenities];
      updatedAmenities.splice(index, 1);
      setHouseAmenities(updatedAmenities);
    }
  };

  //animal allowed handle

  const handleAnimalAllowed = (event) => {
    setPetAllowed(event.target.value === "yes");
  };

  // const handleIncludePriceChange = (e) => {
  //   const value = e.target.value;
  //   setUtilityPrice(value);

  //   // Validate price if price validation is enabled
  //   // if (!isUtilityIncludedPrice && value <= 0) {
  //   //   setInputError(true);
  //   // } else {
  //   //   setInputError(false);
  //   // }
  // };

  console.log("input error,", inputError);

  // const handleCheckboxUtility = (ele) => {
  //   setHouseUtility((prevHouseUtility) => {
  //     if (prevHouseUtility.some((item) => item.name === ele.name)) {
  //       return prevHouseUtility.filter((item) => item.name !== ele.name);
  //     } else {
  //       return [...prevHouseUtility, { ...ele, price: "0" }];
  //     }
  //   });
  // };

  const handleCheckboxUtility = (ele) => {
    setHouseUtility((prevHouseUtility) => {
      if (prevHouseUtility.some((item) => item.name === ele.name)) {
        return prevHouseUtility.filter((item) => item.name !== ele.name);
      } else {
        const { price, ...newEle } = ele; // Destructure to exclude 'price'
        return [...prevHouseUtility, newEle];
      }
    });
  };

  //get utility

  const headers = {
    Authorization: user?.token,
  };
  const getHouseUtility = async () => {
    const res = await axios.get(
      `${import.meta.env.VITE_APP_BASE_URL}/api/house/getUtilities`,
      {
        headers: headers,
      },
    );
    // setIsLoader(false);
    if (res) {
      setUtilityData(res.data.data);
      console.log("response utility", res.data.data);
    } else {
      console.log("error");
    }
  };

  // const handlePriceChange = (utility, price) => {
  //   setHouseUtility((prev) =>
  //     prev.map((item) => (item.name === utility ? { ...item, price } : item))
  //   );
  // };

  const handlePriceChange = (ele, value) => {
    setHouseUtility((prevHouseUtility) =>
      prevHouseUtility.map((item) =>
        item.name === ele.name ? { ...item, price: value } : item,
      ),
    );
  };

  useEffect(() => {
    if (house) {
      let img_s = [];
      img_s = house?.houseImages?.map((ele) => {
        return ele;
      });
      setHouseImages(img_s);

      let docs = [];
      docs = house?.houseDocuments?.map((ele) => {
        return ele;
      });
      setHouseDocImages(docs);
    }
  }, [house]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  }, []);

  const submitPrice = () => { };

  const validateAndSubmit = () => {
    const isValid = houseUtility.every((item) => item.price !== "");
    if (isValid) {
      setError(false);
      submitPrice();
    } else {
      setError(true);
    }
  };

  const handleRadioChange = (e) => {
    // debugger;
    isSetUtilityIncludePrice((prev) => !prev);

    setUtilityPrice(0);
    // const value = e.target.value === 'yes';
    // isSetUtilityIncludePrice(value);

    // // Reset the utility price and input error when "Yes" is selected
    // if (value) {
    //   setUtilityPrice('');
    //   setError(false);
    // }
  };

  //address dropdown
  const states = [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ];

  useEffect(() => {
    getHouseUtility();
    getSecurityInsuranceFee();
  }, []);

  // Fetch security insurance fee from API
  const getSecurityInsuranceFee = async () => {
    try {
      const res = await axios.get(
        `${import.meta.env.VITE_APP_BASE_URL}/api/admin/get/security-insurance-fee`,
        { headers: headers },
      );
      if (res?.data?.data) {
        const fee = parseFloat(res.data.data.security_insurance_fee);
        setSecurityInsuranceFee(fee);
        setInputData((prev) => ({
          ...prev,
          securityPrice: fee,
        }));
      }
    } catch (err) {
      console.log("Error while fetching security insurance fee", err?.message);
    }
  };

  const handleError = (e) => {
    console.error("Failed to load image. URL was:", e.target.src);
    e.target.src = HouseDummyImg; // Fallback to the dummy image on error
  };
  // Replace the handleLocationChange and handleAddressChange functions with these:

  const handleLocationChange = (locationData) => {
    const abbr = locationData.state?.toUpperCase();
    const fullName = stateAbbrevToName[abbr] || locationData.state;
    setInputData((prev) => ({
      ...prev,
      latitude: locationData.latitude,
      longitude: locationData.longitude,
      fullAddress:
        (locationData?.address || "").split(",")[0].trim() || prev.fullAddress,
      city: locationData.city || prev.city,
      state: fullName || prev.state,
      country: locationData.country || prev.country,
      zipCode: locationData.zipCode || prev.zipCode,
    }));
  };

  const handleAddressChange = (address) => {
    setFullAddress(address);
    // setInputData((prev) => ({
    //   ...prev,
    //   fullAddress: address || prev.fullAddress,
    // }));
  };

  // ── CSV HELPERS ────────────────────────────────────────────────────────────────
  const LOCAL_CSV_MAP = {
    'Property Name': 'name',
    'Monthly Rent ($)': 'monthly_price',
    'Security Fee Non Refundable': 'non_refundable_fee',
    'Furnishing Status': 'house_facility',
    'Area (sq ft)': 'area',
    'Min Lease (months)': 'min_lease_period',
    'Street Address': 'full_address',
    'Apt/Suite': 'aprt_suite',
    'State': 'state',
    'ZIP Code': 'zip_code',
    'Country': 'country',
    'City': 'city',
    'Latitude': 'latitude',
    'Longitude': 'longitude',
    'Property Description': 'property_details',
    'Utilities Included': 'utilities_price_included',
    'Total Utilities Price': 'total_utilities_price',
    'Amenities': 'amenities',
    'House Type': 'house_type',
    'Bedrooms': 'bedroom_no',
    'Bathrooms': 'bathroom_no',
    'Floor Number': 'floor',
    'Image URLs': 'house_images_urls',
    'Ownership Document URL': 'house_document_url'
  };
  const LOCAL_CSV_HEADERS = Object.keys(LOCAL_CSV_MAP);

  // Extend mapping to handle shortened or alternative headers exported by Excel
  const HEADER_EXTENSIONS = {
    ...LOCAL_CSV_MAP,
    'Furnishing': 'house_facility',
    'Pets Allowed': 'is_pets_allowed',
    'Pets Allow': 'is_pets_allowed',
    'Image URL': 'house_images_urls',
    'Utilities In': 'utilities_price_included',
    'Total Utilit': 'total_utilities_price',
    'Security Fee': 'non_refundable_fee',
    'Property': 'property_details',
    'Min Lease': 'min_lease_period',
    'Street Ad': 'full_address',
    'Floor': 'floor'
  };
  const FURNITURE_FINDER_MAP = {
    'listing_title':'name','rent_per_month':'monthly_price','deposit':'security_prices',
    'non_refundable':'non_refundable_fee','furnished_status':'house_facility',
    'size_sqft':'area','lease_term_months':'min_lease_period','street_address':'full_address',
    'unit':'aprt_suite','state_name':'state','postal_code':'zip_code','country_name':'country','city_name':'city',
    'lat':'latitude','lng':'longitude','description':'property_details',
    'utils_included':'utilities_price_included','utils_price':'total_utilities_price',
    'pets':'is_pets_allowed','features':'amenities','property_type':'house_type',
    'bedrooms':'bedroom_no','bathrooms':'bathroom_no','floors':'floor',
    'images':'house_images_urls','ownership_doc':'house_document_url'
  };
  const parseCsvText = (text) => {
    const rows=[];let current='',row=[],inQuotes=false;
    for(let i=0;i<text.length;i++){const char=text[i],next=text[i+1];
      if(char==='"'&&inQuotes&&next==='"'){current+='"';i++;}
      else if(char==='"')inQuotes=!inQuotes;
      else if(char===','&&!inQuotes){row.push(current);current='';}
      else if((char==='\n'||char==='\r')&&!inQuotes){if(char==='\r'&&next==='\n')i++;row.push(current);rows.push(row);row=[];current='';}
      else current+=char;}
    if(current||row.length){row.push(current);rows.push(row);}
    return rows;
  };
  const rowToProperty = (headers, row, mapObj=null) => {
    const mapped={};
    const finalMap = mapObj === LOCAL_CSV_MAP ? HEADER_EXTENSIONS : (mapObj || {});
    headers.forEach((h,i)=>{
      const keyStr = h.trim();
      const k = finalMap[keyStr] || finalMap[keyStr.replace(/\s+/g, ' ')];
      if(k) mapped[k]=String(row[i]||'').trim();
    });
    return {...mapped,_status:mapped.house_document_url?'ready':'needs_doc'};
  };
  const resolveImportedPaths = async (properties) => {
    // 1. Initialize loading states
    const initializedProps = properties.map(p => {
      let isImageLoading = false;
      let isDocLoading = false;

      if (p.house_images_urls) {
        const urls = p.house_images_urls.split(/[|,]/).map(u => {
          let clean = u.trim();
          if (clean.startsWith('"') && clean.endsWith('"')) clean = clean.slice(1, -1).trim();
          if (clean.startsWith("'") && clean.endsWith("'")) clean = clean.slice(1, -1).trim();
          return clean;
        }).filter(Boolean);
        const hasUnmigrated = urls.some(u => {
          const isAzure = u.includes('blob.core.windows.net');
          const isUploadedLocal = u.startsWith('upload') || u.startsWith('/upload');
          return u && !isAzure && !isUploadedLocal;
        });
        if (hasUnmigrated) isImageLoading = true;
      }

      if (p.house_document_url) {
        let docUrl = p.house_document_url.trim();
        if (docUrl.startsWith('"') && docUrl.endsWith('"')) docUrl = docUrl.slice(1, -1).trim();
        if (docUrl.startsWith("'") && docUrl.endsWith("'")) docUrl = docUrl.slice(1, -1).trim();
        
        const isAzure = docUrl.includes('blob.core.windows.net');
        const isUploadedLocal = docUrl.startsWith('upload') || docUrl.startsWith('/upload');
        if (docUrl && !isAzure && !isUploadedLocal) isDocLoading = true;
      }

      return { ...p, _imageLoading: isImageLoading, _docLoading: isDocLoading };
    });

    setCsvProperties(initializedProps);

    const currentProps = [...initializedProps];
    for (let i = 0; i < currentProps.length; i++) {
      let p = { ...currentProps[i] };
      let changed = false;

      // 1. Process Images
      if (p.house_images_urls) {
        const urls = p.house_images_urls.split(/[|,]/).map(u => {
          let clean = u.trim();
          if (clean.startsWith('"') && clean.endsWith('"')) clean = clean.slice(1, -1).trim();
          if (clean.startsWith("'") && clean.endsWith("'")) clean = clean.slice(1, -1).trim();
          return clean;
        }).filter(Boolean);
        const azureUrls = [];
        for (const u of urls) {
          const isAzure = u.includes('blob.core.windows.net');
          const isUploadedLocal = u.startsWith('upload') || u.startsWith('/upload');
          if (u && !isAzure && !isUploadedLocal) {
            try {
              const res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload-from-url`, { url: u }, { headers: headerJson });
              if (res.data?.data?.imageUrl) {
                azureUrls.push(res.data.data.imageUrl);
                changed = true;
              } else {
                azureUrls.push(u);
                p._needsLocalUpload = true;
              }
            } catch (err) {
              console.error("Error migrating path:", u, err);
              azureUrls.push(u);
              p._needsLocalUpload = true;
            }
          } else {
            azureUrls.push(u);
          }
        }
        p._imageLoading = false;
        if (changed) {
          p.house_images_urls = azureUrls.join('|');
        }
      } else {
        p._imageLoading = false;
      }

      // 2. Process Document
      if (p.house_document_url) {
        let docUrl = p.house_document_url.trim();
        if (docUrl.startsWith('"') && docUrl.endsWith('"')) docUrl = docUrl.slice(1, -1).trim();
        if (docUrl.startsWith("'") && docUrl.endsWith("'")) docUrl = docUrl.slice(1, -1).trim();
        
        const isAzure = docUrl.includes('blob.core.windows.net');
        const isUploadedLocal = docUrl.startsWith('upload') || docUrl.startsWith('/upload');
        if (docUrl && !isAzure && !isUploadedLocal) {
          try {
            const res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload-from-url`, { url: docUrl }, { headers: headerJson });
            if (res.data?.data?.imageUrl) {
              p.house_document_url = res.data.data.imageUrl;
              p._status = 'ready';
              changed = true;
            } else {
              p._needsLocalUpload = true;
            }
          } catch (err) {
            console.error("Error migrating doc path:", docUrl, err);
            p._needsLocalUpload = true;
          }
        }
        p._docLoading = false;
      } else {
        p._docLoading = false;
      }

      currentProps[i] = p;
      setCsvProperties([...currentProps]);
    }
  };

  const handleLocalFilesUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    let currentProps = [...csvProperties];
    let updated = false;

    for (let file of files) {
      for (let i = 0; i < currentProps.length; i++) {
        let p = { ...currentProps[i] };
        let propChanged = false;

        // Check images
        if (p.house_images_urls) {
          const urls = p.house_images_urls.split(/[|,]/).map(u => u.trim()).filter(Boolean);
          const azureUrls = [];
          for (let u of urls) {
            const isAzure = u.includes('blob.core.windows.net');
            const isUploadedLocal = u.startsWith('upload') || u.startsWith('/upload');
            if (u && !isAzure && !isUploadedLocal) {
              const filename = u.split(/[\\/]/).pop();
              if (filename.toLowerCase() === file.name.toLowerCase()) {
                try {
                  p._imageLoading = true;
                  currentProps[i] = p;
                  setCsvProperties([...currentProps]);

                  let formData = new FormData();
                  formData.append("image", file);
                  let res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`, formData, { headers: headersFormData });
                  if (res?.data?.data?.imageUrl) {
                    azureUrls.push(res.data.data.imageUrl);
                    propChanged = true;
                  } else {
                    azureUrls.push(u);
                  }
                } catch (err) {
                  console.error("Error uploading matched file:", err);
                  azureUrls.push(u);
                }
              } else {
                azureUrls.push(u);
              }
            } else {
              azureUrls.push(u);
            }
          }
          p._imageLoading = false;
          if (propChanged) {
            p.house_images_urls = azureUrls.join('|');
            const hasUnmigrated = azureUrls.some(u => {
              const isAzure = u.includes('blob.core.windows.net');
              const isUploadedLocal = u.startsWith('upload') || u.startsWith('/upload');
              return u && !isAzure && !isUploadedLocal;
            });
            p._needsLocalUpload = hasUnmigrated;
            updated = true;
          }
        }

        // Check document
        if (p.house_document_url) {
          const docUrl = p.house_document_url.trim();
          const isAzure = docUrl.includes('blob.core.windows.net');
          const isUploadedLocal = docUrl.startsWith('upload') || docUrl.startsWith('/upload');
          if (docUrl && !isAzure && !isUploadedLocal) {
            const docFilename = docUrl.split(/[\\/]/).pop();
            if (docFilename.toLowerCase() === file.name.toLowerCase()) {
              try {
                p._docLoading = true;
                currentProps[i] = p;
                setCsvProperties([...currentProps]);

                let formData = new FormData();
                formData.append("image", file);
                let res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`, formData, { headers: headersFormData });
                if (res?.data?.data?.imageUrl) {
                  p.house_document_url = res.data.data.imageUrl;
                  p._status = 'ready';
                  p._docLoading = false;
                  p._needsLocalUpload = false;
                  propChanged = true;
                  updated = true;
                } else {
                  p._docLoading = false;
                }
              } catch (err) {
                console.error("Error uploading matched document:", err);
                p._docLoading = false;
              }
            }
          }
        }

        if (propChanged) {
          currentProps[i] = p;
        }
      }
    }

    if (updated) {
      setCsvProperties([...currentProps]);
    }
  };

  const handleCsvUpload = (e, type) => {
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=()=>{
      const rows=parseCsvText(reader.result);
      if(rows.length<2){alert('CSV has no importable rows.');return;}
      const headers=rows[0].map(h=>h.trim());
      const dataRows=rows.slice(1).filter(r=>r.some(v=>String(v).trim()!==''));
      const mapObj=type==='third'?FURNITURE_FINDER_MAP:LOCAL_CSV_MAP;
      const parsed = dataRows.map(row=>rowToProperty(headers,row,mapObj));
      setCsvProperties(parsed);
      resolveImportedPaths(parsed);
    };
    reader.readAsText(file);
    e.target.value = null; // reset input
  };
  const downloadLocalTemplate = () => {
    const header=LOCAL_CSV_HEADERS.join(',');
    const sample='"Sample Property","1500","300","Fully Furnished","1200","12","123 Main St","Apt 4B","New York","10001","US","New York City","40.7128","-74.0060","Beautiful furnished apartment","No","0","Internet,Parking,Security","Apartment","2","1","3","https://a0.muscache.com/im/pictures/hosting/Hosting-1517439675337635727/original/f138722f-3a47-469e-8a07-656bb622edcb.jpeg?im_w=1200 , https://a0.muscache.com/im/pictures/hosting/Hosting-1517439675337635727/original/f138722f-3a47-469e-8a07-656bb622edcb.jpeg?im_w=1200","https://pdfobject.com/pdf/sample.pdf"';
    const blob=new Blob([header+'\n'+sample],{type:'text/csv;charset=utf-8;'});
    const link=document.createElement('a');link.href=URL.createObjectURL(blob);link.download='druyp_property_template.csv';link.click();URL.revokeObjectURL(link.href);
  };
  
  const [modalUploadLoading, setModalUploadLoading] = useState(false);
  const [modalDocLoading, setModalDocLoading] = useState(false);
  const [showModalMap, setShowModalMap] = useState(false);

  const handleModalLocationChange = (locationData) => {
    const abbr = locationData.state?.toUpperCase();
    const fullName = stateAbbrevToName[abbr] || locationData.state;
    setEditingProperty((prev) => ({
      ...prev,
      latitude: locationData.latitude,
      longitude: locationData.longitude,
      full_address: (locationData?.address || "").split(",")[0].trim() || prev.full_address,
      city: locationData.city || prev.city,
      state: fullName || prev.state,
      country: locationData.country || prev.country,
      zip_code: locationData.zipCode || prev.zip_code,
    }));
  };

  const handleModalAddressChange = (address) => {
    setEditingProperty((p) => ({ ...p, full_address: address }));
  };

  const handleModalImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    
    setModalUploadLoading(true);
    let currentUrls = editingProperty.house_images_urls ? editingProperty.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))) : [];
    
    for (const file of files) {
      let formData = new FormData();
      formData.append("image", file);
      try {
        let res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`, formData, { headers: headersFormData });
        if (res?.data?.data?.imageUrl) {
          currentUrls.push(res.data.data.imageUrl);
        }
      } catch (err) {
        console.log("Error uploading modal image", err);
      }
    }
    setEditingProperty(p => ({ ...p, house_images_urls: currentUrls.join('|') }));
    setModalUploadLoading(false);
    e.target.value = null;
  };

  const removeModalImage = (index) => {
    let currentUrls = editingProperty.house_images_urls ? editingProperty.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))) : [];
    currentUrls.splice(index, 1);
    setEditingProperty(p => ({ ...p, house_images_urls: currentUrls.join('|') }));
  };

  const handleModalDocUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    
    setModalDocLoading(true);
    let formData = new FormData();
    formData.append("image", file);
    try {
      let res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload`, formData, { headers: headersFormData });
      if (res?.data?.data?.imageUrl) {
        setEditingProperty(p => ({ ...p, house_document_url: res.data.data.imageUrl }));
      }
    } catch (err) {
      console.log("Error uploading modal doc", err);
    }
    setModalDocLoading(false);
    e.target.value = null;
  };

  const openEditModal = (index) => { setEditingProperty({...csvProperties[index]}); setEditIndex(index); setShowPropertyEditModal(true); };
  const saveEditedProperty = () => {
    const updated=[...csvProperties];
    updated[editIndex]={...editingProperty,_status:editingProperty.house_document_url?'ready':'needs_doc'};
    setCsvProperties(updated);setShowPropertyEditModal(false);setEditingProperty(null);setEditIndex(null);
  };
  const removeProperty = (index) => { if(window.confirm('Remove this property?'))setCsvProperties(prev=>prev.filter((_,i)=>i!==index)); };

  const handleBulkImport = async () => {
    const readyProperties = csvProperties.filter(p => p._status === 'ready');
    if (readyProperties.length === 0) {
      return alert("No valid properties ready for import. Please ensure they have ownership documents.");
    }

    setBtnLoader(true);
    try {
      const processedProperties = [];
      
      for (const p of readyProperties) {
        let newProperty = { ...p };
        
        // 1. Process House Images
        if (newProperty.house_images_urls) {
          const urls = newProperty.house_images_urls.split(/[|,]/).map(u => u.trim()).filter(Boolean);
          const azureUrls = [];
          for (const u of urls) {
            const isAzure = u.includes('blob.core.windows.net');
            const isUploadedLocal = u.startsWith('upload') || u.startsWith('/upload');
            if (u && !isAzure && !isUploadedLocal) {
              try {
                const res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload-from-url`, { url: u }, { headers: headerJson });
                if (res.data?.data?.imageUrl) {
                  azureUrls.push(res.data.data.imageUrl);
                } else {
                  azureUrls.push(u); // Fallback if upload fails
                }
              } catch (err) {
                console.error("Failed to migrate image path:", u, err);
                azureUrls.push(u); // Keep original if error
              }
            } else {
              azureUrls.push(u); // Already Azure or local
            }
          }
          newProperty.house_images_urls = azureUrls.join('|');
        }
        
        // 2. Process House Document (PDF)
        if (newProperty.house_document_url) {
          const docUrl = newProperty.house_document_url;
          const isAzure = docUrl.includes('blob.core.windows.net');
          const isUploadedLocal = docUrl.startsWith('upload') || docUrl.startsWith('/upload');
          if (docUrl && !isAzure && !isUploadedLocal) {
            try {
              const res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/image/upload-from-url`, { url: docUrl }, { headers: headerJson });
              if (res.data?.data?.imageUrl) {
                newProperty.house_document_url = res.data.data.imageUrl;
              }
            } catch (err) {
              console.error("Failed to migrate doc path:", docUrl, err);
            }
          }
        }
        
        processedProperties.push(newProperty);
      }

      const res = await axios.post(`${import.meta.env.VITE_APP_BASE_URL}/api/house/bulk-import`, {
        properties: processedProperties
      }, { headers: headerJson });
      
      if (res) {
        setCsvProperties([]);
        toggleComponentHouse()
        setActiveMethod('manual');
      }
    } catch (err) {
      console.log("Bulk import error:", err);
      alert("Failed to import properties.");
    }
    setBtnLoader(false);
  };

  return (
    <main>
      <div className="container-fluid px-4">
        <div className="row">
          <div className="col-md-12 col-12">
            <div className="main-box">
              <div className="content-header">
                <h3>{house ? "Update" : "Add New"} House</h3>
                <div
                  onClick={() => {
                    setHouse(null);
                    toggleComponentHouse();
                  }}
                  className="back_arrow clickable"
                  title="Click here to go back."
                >
                  <i className="fa fa-solid fa-arrow-left fa-lg"></i>
                </div>
              </div>

              {/* ─── METHOD SELECTOR ──────────────────────────────────── */}
              {!house && (
                <div className="csv-method-selector">
                  <p className="csv-method-title">How would you like to add property?</p>
                  <div className="csv-method-grid">
                    <div className={`csv-method-card ${activeMethod==='manual'?'active':''}`} onClick={()=>setActiveMethod('manual')}>
                      <div className="csv-method-icon">🏠</div>
                      <h6>Add Manually</h6>
                      <p>Best for adding a single house with images, location, rent, documents, utilities and amenities.</p>
                      <span className="csv-method-pill">Single property</span>
                    </div>
                    <div className={`csv-method-card ${activeMethod==='local'?'active':''}`} onClick={()=>{setActiveMethod('local');setCsvProperties([]);}}>
                      <div className="csv-method-icon">📄</div>
                      <h6>Local CSV Upload</h6>
                      <p>Download the Druyp CSV template, fill property data, then import multiple properties together.</p>
                      <span className="csv-method-pill">Bulk upload</span>
                    </div>
                    <div className={`csv-method-card ${activeMethod==='third'?'active':''}`} onClick={()=>{setActiveMethod('third');setCsvProperties([]);}}>
                      <div className="csv-method-icon">🔁</div>
                      <h6>Third-Party Import</h6>
                      <p>Import CSV data from Furniture Finder. Airbnb and Zillow are future scope.</p>
                      <span className="csv-method-pill">Furniture Finder</span>
                    </div>
                  </div>
                </div>
              )}

              {/* ─── LOCAL CSV PANEL ──────────────────────────────────── */}
              {activeMethod==='local' && !house && (
                <div className="csv-panel-wrap">
                  <h5>Bulk Property Upload via Local CSV</h5>
                  <div className="csv-inner-panel">
                    <p><b>Designed for local property owners.</b> Download the sample template, add your property information, then import the completed CSV into Druyp.</p>
                    <div className="csv-steps">
                      <div className="csv-step"><b>1. Download</b><span>Use the Druyp sample CSV.</span></div>
                      <div className="csv-step"><b>2. Fill Data</b><span>Add property details row by row.</span></div>
                      <div className="csv-step"><b>3. Import</b><span>Validate and create properties.</span></div>
                    </div>
                    <div className="csv-actions">
                      <button type="button" className="sap_blue_btn_outline" onClick={downloadLocalTemplate}>Download Sample CSV</button>
                      <label className="csv-file-label" htmlFor="localCsvInput">Import Completed CSV</label>
                      <input id="localCsvInput" type="file" accept=".csv" hidden onChange={(e)=>handleCsvUpload(e,'local')}/>
                      <button type="button" className="sap_blue_btn_light" onClick={handleBulkImport} disabled={btnLoader}>{btnLoader ? "Importing..." : "Create Valid Properties"}</button>
                      <button type="button" className="sap_blue_btn_outline" onClick={openImagePathGenerator}><i className="fa fa-link" style={{marginRight:'6px'}}></i>Generate Image Link</button>
                    </div>
                    {csvProperties.some(p => p._needsLocalUpload) && (
                      <div className="csv-local-upload-prompt" style={{ marginTop: '16px', padding: '16px', background: '#fff9e6', borderRadius: '12px', border: '1px solid #ffeeba', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                        <span style={{ fontSize: '14px', color: '#856404', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <i className="fa fa-info-circle fa-lg"></i>
                          <span>Some property images or documents are located on your local drive. <b>Please select these files from your computer to upload them to the server.</b></span>
                        </span>
                        <label className="csv-file-label" htmlFor="localMatchInputLocal" style={{ margin: 0, background: '#ffc107', borderColor: '#ffc107', color: '#212529', fontWeight: 'bold' }}>
                          Select Local Files
                        </label>
                        <input id="localMatchInputLocal" type="file" multiple accept="image/*,.pdf" hidden onChange={handleLocalFilesUpload}/>
                      </div>
                    )}
                    {csvProperties.length > 0 && (<>
                      <div className="csv-summary">
                        <span><b>Total Imported:</b> {csvProperties.length}</span>
                        <span className="csv-badge-ok">Ready: {csvProperties.filter(p=>p._status==='ready').length}</span>
                        <span className="csv-badge-warn">Missing Ownership Document: {csvProperties.filter(p=>p._status==='needs_doc').length}</span>
                        <span className="csv-hint">Main list columns: image, name, location, rent, ownership document and actions.</span>
                      </div>
                      {csvProperties.some(p=>p._status==='needs_doc') && <div className="csv-alert">Ownership document is required for every property before final creation.</div>}
                      <div className="csv-table-wrap">
                        <table className="csv-table">
                          <thead><tr><th>Property Image</th><th>Name</th><th>Location</th><th>Monthly Rent</th><th>Ownership Document</th><th>Status</th><th>Action</th></tr></thead>
                          <tbody>
                            {csvProperties.map((p,i)=>(
                              <tr key={i}>
                                <td>
                                  {p._imageLoading ? (
                                    <div className="csv-thumb-loader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '60px', height: '60px', borderRadius: '8px', border: '1px solid #d9e1ea', background: '#f5f7fa' }}>
                                      <i className="fa fa-spinner fa-spin" style={{ color: '#0474ba', fontSize: '20px' }}></i>
                                    </div>
                                  ) : p._needsLocalUpload && !(p.house_images_urls && p.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))).length > 0) ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '60px', height: '60px', borderRadius: '8px', border: '1px solid #ffeeba', background: '#fff9e6', cursor: 'pointer' }} onClick={() => document.getElementById('localMatchInputLocal').click()} title="Click to upload this image from your computer">
                                      <i className="fa fa-upload" style={{ color: '#856404', fontSize: '16px' }}></i>
                                      <span style={{ fontSize: '9px', color: '#856404', marginTop: '2px', fontWeight: 'bold' }}>Upload</span>
                                    </div>
                                  ) : p.house_images_urls && p.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))).length > 0 ? (
                                    <img src={getSafeUrl(p.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload')))[0])} className="csv-thumb" alt="property" style={{objectFit:'cover'}} onError={(e)=>{e.target.onerror=null; e.target.src=HouseDummyImg;}}/>
                                  ) : (
                                    <img src={HouseDummyImg} className="csv-thumb" alt="property"/>
                                  )}
                                </td>
                                <td><div className="csv-prop-name">{p.name||`Imported Property ${i+1}`}</div><small className="csv-prop-sub">{p.house_facility||'Fully Furnished'}</small></td>
                                <td><div>{p.full_address||'Location not added'}</div><small className="csv-prop-sub">{p.country}</small></td>
                                <td><b>$ {p.monthly_price||'0'}</b></td>
                                <td>
                                  {p._docLoading ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', borderRadius: '4px', border: '1px solid #d9e1ea', background: '#f5f7fa' }}>
                                      <i className="fa fa-spinner fa-spin" style={{ color: '#0474ba', fontSize: '16px' }}></i>
                                    </div>
                                  ) : p._needsLocalUpload && !p.house_document_url ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', borderRadius: '4px', border: '1px solid #ffeeba', background: '#fff9e6', cursor: 'pointer' }} onClick={() => document.getElementById('localMatchInputLocal').click()} title="Click to upload this document from your computer">
                                      <i className="fa fa-upload" style={{ color: '#856404', fontSize: '12px' }}></i>
                                      <span style={{ fontSize: '8px', color: '#856404', marginTop: '2px', fontWeight: 'bold' }}>Doc</span>
                                    </div>
                                  ) : p.house_document_url ? (
                                    <img
                                      style={{ width: "40px", height: "40px", objectFit: 'cover', borderRadius: '4px' }}
                                      src={getSafeUrl(p.house_document_url)}
                                      alt="document"
                                      onError={(e) => {
                                        e.target.src = UploadImg;
                                      }}
                                    />
                                  ) : (
                                    <span className="csv-badge-warn">Required</span>
                                  )}
                                </td>
                                <td><span className={`csv-status ${p._status==='ready'?'csv-status-ok':'csv-status-err'}`}>{p._status==='ready'?'Ready':'Needs Document'}</span></td>
                                <td>
                                  <button className="csv-action-btn csv-action-edit" type="button" onClick={()=>openEditModal(i)}>Detail / Edit</button>
                                  <button className="csv-action-btn csv-action-remove" type="button" onClick={()=>removeProperty(i)}>Remove</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>)}
                  </div>
                </div>
              )}

              {/* ─── THIRD-PARTY CSV PANEL ────────────────────────────── */}
              {activeMethod==='third' && !house && (
                <div className="csv-panel-wrap">
                  <h5>Third-Party CSV Import</h5>
                  <div className="csv-inner-panel">
                    <p><b>Current scope:</b> Furniture Finder CSV import. Airbnb and Zillow are future scope — each platform requires different field mapping.</p>
                    <div className="csv-actions" style={{flexDirection:'column',alignItems:'flex-start',gap:'12px',marginBottom:'12px'}}>
                      <div style={{width:'300px'}}>
                        <label className="csv-field-label">Select Platform</label>
                        <select className="csv-select"><option>Furniture Finder</option><option disabled>Airbnb — Future Scope</option><option disabled>Zillow — Future Scope</option></select>
                      </div>
                      <div style={{width:'300px'}}>
                        <label className="csv-field-label">Upload Third-Party CSV</label>
                        <input type="file" accept=".csv" onChange={(e)=>handleCsvUpload(e,'third')} className="csv-file-input"/>
                      </div>
                    </div>
                    <p className="csv-warn-text">Each additional third-party CSV format will require minimum 2 working days of development effort.</p>
                    <div className="csv-actions">
                      <button type="button" className="sap_blue_btn_light" onClick={handleBulkImport} disabled={btnLoader}>{btnLoader ? "Importing..." : "Create Valid Properties"}</button>
                      <button type="button" className="sap_blue_btn_outline" onClick={openImagePathGenerator}><i className="fa fa-link" style={{marginRight:'6px'}}></i>Generate Image Link</button>
                    </div>
                    {csvProperties.some(p => p._needsLocalUpload) && (
                      <div className="csv-local-upload-prompt" style={{ marginTop: '16px', padding: '16px', background: '#fff9e6', borderRadius: '12px', border: '1px solid #ffeeba', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                        <span style={{ fontSize: '14px', color: '#856404', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <i className="fa fa-info-circle fa-lg"></i>
                          <span>Some property images or documents are located on your local drive. <b>Please select these files from your computer to upload them to the server.</b></span>
                        </span>
                        <label className="csv-file-label" htmlFor="localMatchInputThird" style={{ margin: 0, background: '#ffc107', borderColor: '#ffc107', color: '#212529', fontWeight: 'bold' }}>
                          Select Local Files
                        </label>
                        <input id="localMatchInputThird" type="file" multiple accept="image/*,.pdf" hidden onChange={handleLocalFilesUpload}/>
                      </div>
                    )}
                    {csvProperties.length > 0 && (<>
                      <div className="csv-summary">
                        <span><b>Total Imported:</b> {csvProperties.length}</span>
                        <span className="csv-badge-ok">Ready: {csvProperties.filter(p=>p._status==='ready').length}</span>
                        <span className="csv-badge-warn">Missing Ownership Document: {csvProperties.filter(p=>p._status==='needs_doc').length}</span>
                      </div>
                      {csvProperties.some(p=>p._status==='needs_doc') && <div className="csv-alert">Ownership document is required for every property before final creation.</div>}
                      <div className="csv-table-wrap">
                        <table className="csv-table">
                          <thead><tr><th>Property Image</th><th>Name</th><th>Location</th><th>Monthly Rent</th><th>Ownership Document</th><th>Status</th><th>Action</th></tr></thead>
                          <tbody>
                            {csvProperties.map((p,i)=>(
                              <tr key={i}>
                                <td>
                                  {p._imageLoading ? (
                                    <div className="csv-thumb-loader" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '60px', height: '60px', borderRadius: '8px', border: '1px solid #d9e1ea', background: '#f5f7fa' }}>
                                      <i className="fa fa-spinner fa-spin" style={{ color: '#0474ba', fontSize: '20px' }}></i>
                                    </div>
                                  ) : p._needsLocalUpload && !(p.house_images_urls && p.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))).length > 0) ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '60px', height: '60px', borderRadius: '8px', border: '1px solid #ffeeba', background: '#fff9e6', cursor: 'pointer' }} onClick={() => document.getElementById('localMatchInputThird').click()} title="Click to upload this image from your computer">
                                      <i className="fa fa-upload" style={{ color: '#856404', fontSize: '16px' }}></i>
                                      <span style={{ fontSize: '9px', color: '#856404', marginTop: '2px', fontWeight: 'bold' }}>Upload</span>
                                    </div>
                                  ) : p.house_images_urls && p.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))).length > 0 ? (
                                    <img src={getSafeUrl(p.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload')))[0])} className="csv-thumb" alt="property" style={{objectFit:'cover'}} onError={(e)=>{e.target.onerror=null; e.target.src=HouseDummyImg;}}/>
                                  ) : (
                                    <img src={HouseDummyImg} className="csv-thumb" alt="property"/>
                                  )}
                                </td>
                                <td><div className="csv-prop-name">{p.name||`Imported Property ${i+1}`}</div><small className="csv-prop-sub">{p.house_facility}</small></td>
                                <td><div>{p.full_address||'Location not added'}</div><small className="csv-prop-sub">{p.country}</small></td>
                                <td><b>$ {p.monthly_price||'0'}</b></td>
                                <td>
                                  {p._docLoading ? (
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', borderRadius: '4px', border: '1px solid #d9e1ea', background: '#f5f7fa' }}>
                                      <i className="fa fa-spinner fa-spin" style={{ color: '#0474ba', fontSize: '16px' }}></i>
                                    </div>
                                  ) : p._needsLocalUpload && !p.house_document_url ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: '40px', height: '40px', borderRadius: '4px', border: '1px solid #ffeeba', background: '#fff9e6', cursor: 'pointer' }} onClick={() => document.getElementById('localMatchInputThird').click()} title="Click to upload this document from your computer">
                                      <i className="fa fa-upload" style={{ color: '#856404', fontSize: '12px' }}></i>
                                      <span style={{ fontSize: '8px', color: '#856404', marginTop: '2px', fontWeight: 'bold' }}>Doc</span>
                                    </div>
                                  ) : p.house_document_url ? (
                                    <img
                                      style={{ width: "40px", height: "40px", objectFit: 'cover', borderRadius: '4px' }}
                                      src={getSafeUrl(p.house_document_url)}
                                      alt="document"
                                      onError={(e) => {
                                        e.target.src = UploadImg;
                                      }}
                                    />
                                  ) : (
                                    <span className="csv-badge-warn">Required</span>
                                  )}
                                </td>
                                <td><span className={`csv-status ${p._status==='ready'?'csv-status-ok':'csv-status-err'}`}>{p._status==='ready'?'Ready':'Needs Document'}</span></td>
                                <td>
                                  <button className="csv-action-btn csv-action-edit" type="button" onClick={()=>openEditModal(i)}>Detail / Edit</button>
                                  <button className="csv-action-btn csv-action-remove" type="button" onClick={()=>removeProperty(i)}>Remove</button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>)}
                  </div>
                </div>
              )}

              {/* ─── DETAIL / EDIT MODAL ──────────────────────────────── */}
              <Modal open={showPropertyEditModal} onCancel={()=>setShowPropertyEditModal(false)} footer={null}
                title={<span style={{fontSize:'18px',fontWeight:'bold'}}>Imported Property — Detail / Edit</span>} width={860}>
                {editingProperty && (
                  <div className="csv-edit-modal">
                    <p className="csv-modal-note"><b>Review and edit all fields before final import.</b> Images and Ownership document are required.</p>
                    
                    <div style={{marginTop:'14px', border:'1px solid #d9e1ea', borderRadius:'12px', padding:'16px', background:'#fbfdff', marginBottom:'20px'}}>
                      <label className="csv-field-label">Upload House Images (JPG, PNG)</label>
                      <input type="file" multiple accept=".jpg,.jpeg,.png" onChange={handleModalImageUpload} className="csv-file-input" style={{marginBottom:'8px'}} disabled={modalUploadLoading} />
                      {modalUploadLoading && <div style={{fontSize:'12px', color:'#0474ba', fontWeight:'bold'}}>Uploading images... Please wait.</div>}
                      {editingProperty.house_images_urls && (
                        <div className="add_new_progres" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginTop: '8px' }}>
                          {editingProperty.house_images_urls.split(/[|,]/).map(u=>u.trim()).filter(u => u && (u.startsWith('http') || u.startsWith('upload') || u.startsWith('/upload'))).map((u, i) => (
                            <div key={i} className="upload_jpg">
                              <div className="doc_img">
                                <img src={getSafeUrl(u)} alt="Upload" onError={(e) => { e.target.src = HouseDummyImg; }} />
                              </div>
                              <div className="file_jpg_main">
                                <div className="file_jpg">
                                </div>
                              </div>
                              <div className="close_icon" onClick={() => removeModalImage(i)}>
                                <img src={CloseCircleSvg} alt="close-circle" />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div style={{marginTop:'14px', border:'1px solid #d9e1ea', borderRadius:'12px', padding:'16px', background:'#fbfdff', marginBottom:'20px'}}>
                      <label className="csv-field-label">Upload Ownership Document (PDF) <span style={{color:'red'}}>*Required</span></label>
                      <input type="file" accept=".pdf" onChange={handleModalDocUpload} className="csv-file-input" style={{marginBottom:'8px'}} disabled={modalDocLoading} />
                      {modalDocLoading && <div style={{fontSize:'12px', color:'#0474ba', fontWeight:'bold'}}>Uploading document... Please wait.</div>}
                      {editingProperty.house_document_url && (
                        <div className="owner_doc_inner" style={{ marginTop: '10px' }}>
                          <div className="owner_img" style={{ position: 'relative', width: '120px', height: '120px' }}>
                            <div className="close_icon" onClick={() => setEditingProperty(p => ({ ...p, house_document_url: '' }))}>
                              <img src={CloseCircleSvg} alt="close-circle" />
                            </div>
                            <img
                              src={getSafeUrl(editingProperty.house_document_url)}
                              alt="document"
                              onError={(e) => {
                                e.target.src = UploadImg;
                              }}
                              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '12px' }}
                            />
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="csv-modal-grid csv-modal-grid-2">
                      <div><label className="csv-field-label">Property Name</label><input className="csv-field-input" value={editingProperty.name||''} onChange={e=>setEditingProperty(p=>({...p,name:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Monthly Rent ($)</label><input className="csv-field-input" type="number" value={editingProperty.monthly_price||''} onChange={e=>setEditingProperty(p=>({...p,monthly_price:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Security Fee Non Refundable</label><input className="csv-field-input" type="number" value={editingProperty.non_refundable_fee||''} onChange={e=>setEditingProperty(p=>({...p,non_refundable_fee:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Floor</label><input className="csv-field-input" type="number" value={editingProperty.floor||''} onChange={e=>setEditingProperty(p=>({...p,floor:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Bedrooms</label><input className="csv-field-input" type="number" value={editingProperty.bedroom_no||''} onChange={e=>setEditingProperty(p=>({...p,bedroom_no:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Bathrooms</label><input className="csv-field-input" type="number" value={editingProperty.bathroom_no||''} onChange={e=>setEditingProperty(p=>({...p,bathroom_no:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Furnishing Status</label><select className="csv-field-input" value={editingProperty.house_facility||''} onChange={e=>setEditingProperty(p=>({...p,house_facility:e.target.value}))}><option>Fully Furnished</option><option>Semi Furnished</option><option>Unfurnished</option></select></div>
                      <div><label className="csv-field-label">Area (sq ft)</label><input className="csv-field-input" type="number" value={editingProperty.area||''} onChange={e=>setEditingProperty(p=>({...p,area:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Min Lease (months)</label><input className="csv-field-input" type="number" value={editingProperty.min_lease_period||''} onChange={e=>setEditingProperty(p=>({...p,min_lease_period:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Utilities Included?</label><select className="csv-field-input" value={editingProperty.utilities_price_included||'No'} onChange={e=>setEditingProperty(p=>({...p,utilities_price_included:e.target.value}))}><option>No</option><option>Yes</option></select></div>
                      <div><label className="csv-field-label">Utility Total ($)</label><input className="csv-field-input" type="number" value={editingProperty.total_utilities_price||''} onChange={e=>setEditingProperty(p=>({...p,total_utilities_price:e.target.value}))}/></div>
                      <div><label className="csv-field-label">Amenities</label><input className="csv-field-input" value={editingProperty.amenities||''} onChange={e=>setEditingProperty(p=>({...p,amenities:e.target.value}))} placeholder="Internet,Parking,Security"/></div>
                      <div><label className="csv-field-label">House Type</label><select className="csv-field-input" value={editingProperty.house_type||''} onChange={e=>setEditingProperty(p=>({...p,house_type:e.target.value}))}><option>Apartment</option><option>House</option><option>Condo</option><option>Studio</option><option>Townhouse</option></select></div>
                    </div>
                    
                    <div style={{marginTop:'14px'}}><label className="csv-field-label">Property Details</label><textarea className="csv-field-input" rows={3} value={editingProperty.property_details||''} onChange={e=>setEditingProperty(p=>({...p,property_details:e.target.value}))}/></div>

                    <div className="location-section" style={{marginTop:'20px', border:'1px solid #d9e1ea', borderRadius:'12px', padding:'16px', background:'#fbfdff'}}>
                      <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-3">
                        <label className="csv-field-label m-0">Property Location (Map Search)</label>
                      </div>
                      <div style={{marginTop:'10px', marginBottom:'20px'}}>
                        {USE_Maps ? (
                          <GoogleMapsSelector
                            initialLatitude={editingProperty.latitude}
                            initialLongitude={editingProperty.longitude}
                            initialAddress={editingProperty.full_address}
                            onLocationChange={handleModalLocationChange}
                            onAddressChange={handleModalAddressChange}
                            googleMapsApiKey={Maps_API_KEY}
                            mapHeight="300px"
                            hideInstructions={true}
                          />
                        ) : (
                          <LocationSelectorMap
                            initialLatitude={editingProperty.latitude}
                            initialLongitude={editingProperty.longitude}
                            initialAddress={editingProperty.full_address}
                            onLocationChange={handleModalLocationChange}
                            onAddressChange={handleModalAddressChange}
                            showAddressSearch={true}
                            showCurrentLocation={true}
                            showCoordinateInputs={true}
                            mapHeight="300px"
                          />
                        )}
                      </div>
                      
                      <div className="csv-modal-grid csv-modal-grid-2">
                        <div><label className="csv-field-label">Country</label><input className="csv-field-input" value={editingProperty.country||''} onChange={e=>setEditingProperty(p=>({...p,country:e.target.value}))} disabled/></div>
                        <div><label className="csv-field-label">Full Address (Street)</label><input className="csv-field-input" value={editingProperty.full_address||''} onChange={e=>setEditingProperty(p=>({...p,full_address:e.target.value}))}/></div>
                        <div><label className="csv-field-label">Apt/Suite</label><input className="csv-field-input" value={editingProperty.aprt_suite||''} onChange={e=>setEditingProperty(p=>({...p,aprt_suite:e.target.value}))}/></div>
                        <div><label className="csv-field-label">City</label><input className="csv-field-input" value={editingProperty.city||''} onChange={e=>setEditingProperty(p=>({...p,city:e.target.value}))}/></div>
                        <div><label className="csv-field-label">State</label><input className="csv-field-input" value={editingProperty.state||''} onChange={e=>setEditingProperty(p=>({...p,state:e.target.value}))}/></div>
                        <div><label className="csv-field-label">ZIP Code</label><input className="csv-field-input" value={editingProperty.zip_code||''} onChange={e=>setEditingProperty(p=>({...p,zip_code:e.target.value}))}/></div>
                      </div>
                    </div>
                    
                    <div style={{display:'flex',gap:'12px',marginTop:'20px',justifyContent:'flex-end'}}>
                      <button type="button" className="sap_blue_btn_outline" onClick={()=>setShowPropertyEditModal(false)}>Cancel</button>
                      <button type="button" style={{borderRadius:'999px',border:0,background:'#0474ba',color:'#fff',padding:'10px 24px',fontWeight:800,cursor:'pointer',fontFamily:'inherit'}} onClick={saveEditedProperty}>Save Changes</button>
                    </div>
                  </div>
                )}
              </Modal>

              {/* ─── EXISTING MANUAL FORM ─────────────────────────────── */}
              {(activeMethod==='manual' || !!house) && (
              <div className="row">
                <div className="col-12">
                  <div className="add_new_img_upload">
                    <div className="house_upload_head">
                      Upload your House Images
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="add_new_house">
                          <div className="Neon Neon-theme-dragdropbox">
                            <input
                              id="filer_input2"
                              name="files[]"
                              type="file"
                              multiple
                              accept=".jpg, .png, .jpeg"
                              onChange={(e) => handleHouseImages(e)}
                              onClick={(e) => (e.target.value = null)}
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false || houseImages.length >= 40
                              }
                            />
                            <div className="Neon-input-dragDrop">
                              <div className="Neon-input-inner">
                                <div className="Neon-input-icon">
                                  <img src={UploadImg} />
                                </div>
                                <div className="Neon-input-text">
                                  <p>
                                    Drop your file here to upload or select from
                                    storage
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                          {inputError && houseImages?.length <= 0 && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please upload your house images!
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="add_new_progres">
                          {uploadingImages?.length > 0 &&
                            uploadingImages?.map((item) => (
                              <div key={item.id} className="upload_jpg" style={{ opacity: 0.7 }}>
                                <div className="doc_img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  <div style={{ width: 50, height: 50 }}>
                                    <CircularProgressbar
                                      value={item.progress}
                                      text={`${item.progress}%`}
                                      styles={buildStyles({
                                        textSize: '24px',
                                        pathColor: item.error ? 'red' : '#3e98c7',
                                        textColor: item.error ? 'red' : '#3e98c7',
                                      })}
                                    />
                                  </div>
                                </div>
                                <div className="file_jpg_main">
                                  <div className="file_jpg">
                                    <h4 style={{ color: item.error ? 'red' : 'inherit', fontSize: '12px' }}>
                                      {item.error ? item.error : item.file.name}
                                    </h4>
                                  </div>
                                </div>
                              </div>
                            ))}
                          {houseImages?.length > 0 &&
                            houseImages?.map((value, i) => (
                              <div key={i} className="upload_jpg">
                                <div className="doc_img">
                                  {(value?.localPreview || value?.imageUrl) ? (
                                    <img
                                      src={
                                        value?.localPreview || getSafeUrl(value?.imageUrl)
                                      }
                                      alt="histhomeimg"
                                      onError={handleError}
                                    />
                                  ) : (
                                    <img
                                      src={HouseDummyImg}
                                      alt="histhomeimg"
                                    />
                                  )}
                                  {/* <img
                                    src={
                                      getSafeUrl(value?.imageUrl) || HouseDummyImg
                                    }
                                    alt="histhomeimg"
                                  /> */}
                                </div>

                                <div
                                  key={i + "_images"}
                                  className="file_jpg_main"
                                >
                                  <div className="file_jpg">
                                    {/* <h4>{value?.name}</h4> */}
                                    {/* <div style={{ width: 50, height: 50 }}>
                    <CircularProgressbar
                      value={100}
                      text={`${100}%`}
                      styles={buildStyles({
                        textSize: '24px',
                        pathColor: '#3e98c7',
                        textColor: '#3e98c7',
                      })}
                    />
                  </div> */}
                                  </div>
                                </div>
                                <div
                                  className="close_icon"
                                  // onClick={() => removeImage(i)}
                                  onClick={() =>
                                    house?.booking_status !== "Booked"
                                      ? removeImage(i)
                                      : null
                                  } // Conditionally prevent image removal
                                  style={{
                                    pointerEvents:
                                      house?.booking_status === "Booked"
                                        ? "none"
                                        : "auto", // Disable click functionality
                                    opacity:
                                      house?.booking_status === "Booked"
                                        ? 0.5
                                        : 1, // Optional: make the icon look disabled
                                  }}
                                >
                                  <img
                                    src={CloseCircleSvg}
                                    alt="close-circle"
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr className="m-0" />
                  <div className="new_house_field_main">
                    <div className="row">
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="propertyName" className="form-label">
                            Property Name
                          </label>
                          <Tooltip title='Follow the format: (Verb, Noun, City, and State). Example "Beautiful home in Forest Hills New York.","Yummy Condo in Jackson Height, Queens"'>
                            <input
                              type="text"
                              className="form-control"
                              id="propertyName"
                              placeholder="Enter property name"
                              name="name"
                              value={inputData?.propertyName}
                              onKeyPress={(e) => {
                                if (!/^[a-zA-Z \s]+$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                let text = e.target.value;
                                if (text.length > 100) {
                                  text = text.substring(0, 100);
                                }
                                text = text.replace(
                                  /\b(?:one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|thirteen|fourteen|fifteen|sixteen|seventeen|eighteen|nineteen|twenty|thirty|forty|fifty|sixty|seventy|eighty|ninety|hundred|thousand|million|billion)\b/gi,
                                  "",
                                );
                                text = text.replace(/\b\d+\b/g, "");
                                setInputData({
                                  ...inputData,
                                  propertyName: text,
                                });
                              }}
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                          </Tooltip>
                          {inputError && !inputData?.propertyName && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter your property name!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="monthlyPrice" className="form-label">
                            Enter Monthly Rent{" "}
                          </label>
                          {/* <input
                            type="tel"
                            className="form-control"
                            id="monthlyPrice"
                            placeholder="Enter Monthly Price"
                            name="monthly_price"
                            value={inputData?.monthlyPrice}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                monthlyPrice: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          /> */}
                          <InputNumber
                            // className="form-control"
                            min={1}
                            max={100000000}
                            //style={{width:"100%"}}
                            prefix="$"
                            id="monthlyPrice"
                            placeholder="Enter Monthly Rent"
                            name="monthly_price"
                            value={inputData?.monthlyPrice}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(value) =>
                              setInputData({
                                ...inputData,
                                monthlyPrice: value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          />
                          {inputError && !inputData?.monthlyPrice && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter monthly price!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="securityPrice" className="form-label">
                            Security Fee (One time Non-Refundable)
                          </label>
                          <InputNumber
                            type="tel"
                            prefix="$"
                            min={0}
                            max={100000000}
                            // className="form-control"
                            id="securityPrice"
                            placeholder="Security Fee (One time Non-Refundable)"
                            name="non_refundable_fee"
                            value={inputData?.non_refundable_fee}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(value) =>
                              setInputData({
                                ...inputData,
                                non_refundable_fee: value,
                              })
                            }
                          />
                          {inputError && !inputData?.non_refundable_fee && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter security fee!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="securityPrice" className="form-label">
                            Security Insurance Fee (Monthly)
                          </label>
                          <InputNumber
                            type="tel"
                            prefix="$"
                            min={0}
                            max={100000000}
                            // className="form-control"
                            id="securityPrice"
                            placeholder="Security Insurance Fee (Monthly)"
                            name="security_prices"
                            value={inputData?.securityPrice}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(value) =>
                              setInputData({
                                ...inputData,
                                securityPrice: value,
                              })
                            }
                            disabled={true}
                          />
                          {inputError &&
                            (inputData?.securityPrice === "" ||
                              inputData?.securityPrice === null ||
                              inputData?.securityPrice === undefined) && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please enter security insurance fee!
                              </div>
                            )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field new_house_select">
                          <label htmlFor="houseType" className="form-label">
                            House Type
                          </label>
                          <select
                            id="houseType"
                            className="form-select"
                            aria-label="Default select example"
                            name="house_type"
                            value={inputData?.houseType}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                houseType: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          >
                            <option value={"Apartment"}>Apartment</option>
                            <option value={"Villa"}>Villa</option>
                            <option value={"House"}>House</option>
                            <option value={"Office"}>Office</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="floorCount" className="form-label">
                            Enter Floor
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            id="floorCount"
                            name="floor"
                            placeholder="2"
                            value={inputData?.floorCount}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                floorCount: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          />
                          {inputError && !inputData?.floorCount && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter floor!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="numBedrooms" className="form-label">
                            Enter Number Of Bedrooms
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            id="numBedrooms"
                            name="bedroom_no"
                            placeholder="4"
                            value={inputData?.bedroomCount}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                bedroomCount: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          />
                          {inputError && !inputData?.bedroomCount && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter number of bedrooms!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="numBathroom" className="form-label">
                            Enter Number Of Bathrooms
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="numBathroom"
                            name="bathroom_no"
                            placeholder="2"
                            value={inputData?.bathroomCount}
                            onChange={(e) => {
                              if (/^\d*\.?(?:0|5)?$/.test(e.target.value)) {
                                setInputData({
                                  ...inputData,
                                  bathroomCount: e.target.value,
                                });
                              }
                            }}
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          />
                          {inputError && !inputData?.bathroomCount && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter number of bathrooms!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field new_house_select">
                          <label
                            htmlFor="propertyOptions"
                            className="form-label"
                          >
                            Property Options
                          </label>
                          <select
                            id="propertyOptions"
                            className="form-select"
                            aria-label="Default select example"
                            name="house_facility"
                            value={inputData?.propertyOption}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                propertyOption: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          >
                            <option value={"Fully Furnished"}>
                              Fully Furnished
                            </option>
                            <option value={"Customize"}>Unfurnished</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="propertyArea" className="form-label">
                            SQ FT
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            id="propertyArea"
                            name="area"
                            placeholder="1500"
                            value={inputData?.propertyAreaCount}
                            onKeyPress={(e) => {
                              if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                propertyAreaCount: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          />
                          {inputError && !inputData?.propertyAreaCount && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please Enter Property SQ FT!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="mb-3 new_house_field">
                          <label htmlFor="leaseCount" className="form-label">
                            Minimum Lease Period (in months)
                          </label>
                          <div className="input-group">
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={() =>
                                setInputData((prevInputData) => ({
                                  ...prevInputData,
                                  leasePeriodCount: Math.max(
                                    prevInputData.leasePeriodCount - 1,
                                    1,
                                  ),
                                }))
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            >
                              -
                            </button>
                            <input
                              type="tel"
                              className="form-control"
                              id="leaseCount"
                              value={inputData?.leasePeriodCount}
                              onKeyPress={(e) => {
                                if (!/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  leasePeriodCount: e.target.value,
                                })
                              }
                              readOnly
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                            <button
                              className="btn btn-outline-secondary"
                              type="button"
                              onClick={() =>
                                setInputData((prevInputData) => ({
                                  ...prevInputData,
                                  leasePeriodCount:
                                    prevInputData.leasePeriodCount + 1,
                                }))
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                      <hr className="mt-3 p-1"></hr>

                      <div className="location-section">
                        <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap gap-3">
                          <h5>Property Location</h5>
                          <div>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => setShowMap(!showMap)}
                            >
                              {showMap ? "Hide Map" : "📍 Select on Map"}
                            </Button>
                          </div>
                        </div>

                        {showMap && (
                          <>
                            {USE_Maps ? (
                              <GoogleMapsSelector
                                initialLatitude={inputData.latitude}
                                initialLongitude={inputData.longitude}
                                initialAddress={fullAddress}
                                onLocationChange={handleLocationChange}
                                onAddressChange={handleAddressChange}
                                googleMapsApiKey={Maps_API_KEY}
                                mapHeight="400px"
                                className="mb-3"
                                hideInstructions={true}
                              />
                            ) : (
                              <LocationSelectorMap
                                initialLatitude={inputData.latitude}
                                initialLongitude={inputData.longitude}
                                initialAddress={inputData.fullAddress}
                                onLocationChange={handleLocationChange}
                                onAddressChange={handleAddressChange}
                                showAddressSearch={true}
                                showCurrentLocation={true}
                                showCoordinateInputs={true}
                                mapHeight="400px"
                                className="mb-3"
                              />
                            )}
                          </>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3 new_house_field">
                            <label htmlFor="country" className="form-label">
                              Country
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="country"
                              placeholder="Country"
                              name="country"
                              value={inputData?.country}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  country: e.target.value,
                                })
                              }
                              disabled
                            />
                            {inputError && !inputData?.country && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please enter your country!
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-9 col-md-9">
                          <div className="mb-3 new_house_field">
                            <label
                              htmlFor="exampleFormControlInput9"
                              className="form-label"
                            >
                              Address{" "}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="exampleFormControlInput9"
                              placeholder="Enter  Address"
                              name="address"
                              value={inputData?.fullAddress}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  fullAddress: e.target.value,
                                })
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                            {inputError && !inputData?.fullAddress && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please enter your full address!
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3 new_house_field">
                            <label htmlFor="aprSuite" className="form-label">
                              Apartment/Suite
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="aprSuite"
                              placeholder="Apartment/Suite"
                              name="aprSuite"
                              value={inputData?.aprt_suite}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  aprt_suite: e.target.value,
                                })
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                            {/* {inputError && !inputData?.aprt_suite && (
                                <div className="sap-val-error text-danger mb-0 mt-1">
                                  Please enter your apartment no. or suite!
                                </div>
                              )} */}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3 new_house_field">
                            <label htmlFor="city" className="form-label">
                              City
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="city"
                              placeholder="City"
                              name="city"
                              value={inputData?.city}
                              onKeyPress={(e) => {
                                if (!/^[a-zA-Z \s]+$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  city: e.target.value,
                                })
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                            {inputError && !inputData?.city && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please enter your city!
                              </div>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-lg-3 col-md-6">
                          <div className="mb-3 new_house_field">
                            <label htmlFor="state" className="form-label">
                              State
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="state"
                              placeholder="State"
                              name="state"
                              value={inputData?.state}
                              onKeyPress={(e) => {
                                if (!/^[a-zA-Z \s]+$/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  state: e.target.value,
                                })
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                            {inputError && !inputData?.state && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please enter your state!
                              </div>
                            )}
                          </div>
                        </div> */}

                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3 new_house_field">
                            <label htmlFor="state" className="form-label">
                              State
                            </label>
                            <select
                              style={{ height: "56px" }}
                              className="form-control"
                              id="state"
                              name="state"
                              value={inputData?.state}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  state: e.target.value,
                                })
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                              }
                            >
                              <option value="">Select a State</option>
                              {states.map((state, index) => (
                                <option key={index} value={state}>
                                  {state}
                                </option>
                              ))}
                            </select>
                            {inputError && !inputData?.state && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please enter your state!
                              </div>
                            )}
                          </div>
                        </div>

                        {/* <select style={{width:"100px",}}>
      {states.map((state, index) => (
        <option key={index} value={state}>
          {state}
        </option>
      ))}
    </select> */}
                        <div className="col-lg-3 col-md-6">
                          <div className="mb-3 new_house_field">
                            <label htmlFor="zipCode" className="form-label">
                              Zip Code
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="zipCode"
                              name="zip_code"
                              placeholder="Zip Code"
                              value={inputData?.zipCode}
                              onChange={(e) =>
                                setInputData({
                                  ...inputData,
                                  zipCode: e.target.value,
                                })
                              }
                              disabled={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            />
                            {inputError &&
                              (!inputData?.zipCode ||
                                !zipRegex.test(inputData?.zipCode)) && (
                                <div className="sap-val-error text-danger mb-0 mt-1">
                                  {!inputData?.zipCode
                                    ? "Please enter your zip code!"
                                    : !zipRegex.test(inputData?.zipCode)
                                      ? "Invalid zip code"
                                      : ""}
                                </div>
                              )}
                          </div>
                        </div>
                        {!showMap && (
                          <Row>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <label
                                  htmlFor="latitude"
                                  className="form-label"
                                >
                                  Latitude
                                </label>
                                {/* <Form.Label>Latitude</Form.Label> */}
                                <Form.Control
                                  type="number"
                                  step="0.00000001"
                                  value={inputData.latitude}
                                  onChange={(e) =>
                                    setInputData((prev) => ({
                                      ...prev,
                                      latitude: e.target.value,
                                    }))
                                  }
                                  placeholder="Enter latitude or select on map"
                                />
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group className="mb-3">
                                <label
                                  htmlFor="longitude"
                                  className="form-label"
                                >
                                  Longitude
                                </label>

                                <Form.Control
                                  type="number"
                                  step="0.00000001"
                                  value={inputData.longitude}
                                  onChange={(e) =>
                                    setInputData((prev) => ({
                                      ...prev,
                                      longitude: e.target.value,
                                    }))
                                  }
                                  placeholder="Enter longitude or select on map"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        )}
                      </div>
                      <hr className="mt-3 p-1"></hr>
                      <div className="col-12">
                        <div className="mb-3 new_house_field">
                          <label
                            htmlFor="propertyDetail"
                            className="form-label"
                          >
                            Property Details
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            id="propertyDetail"
                            placeholder="Property Details..."
                            name="property_details"
                            value={inputData?.propertyDetail}
                            onKeyPress={(e) => {
                              if (!/^[a-zA-Z \-,.]+$/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) =>
                              setInputData({
                                ...inputData,
                                propertyDetail: e.target.value,
                              })
                            }
                            disabled={
                              house && house.booking_status === "Booked"
                                ? true
                                : false
                            }
                          />
                          {inputError && !inputData?.propertyDetail && (
                            <div className="sap-val-error text-danger mb-0 mt-1">
                              Please enter property details!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="owner_doc">
                          <h4>
                            {user?.currentRole === "property_manager"
                              ? "Upload Property Management Agreement and House Ownership Agreement Document"
                              : "Upload House Ownership Document"}{" "}
                            <span className="text-danger">
                              (*Accept only .pdf, .docx)
                            </span>
                          </h4>
                          <div className="owner_doc_inner">
                            <div className="Neon Neon-theme-dragdropbox">
                              <input
                                id="filer_input2"
                                name="files[]"
                                type="file"
                                accept=".pdf, .docx" // Specify the accepted file types
                                onChange={(e) => handleHouseDocs(e)}
                                onClick={(e) => (e.target.value = null)}
                                disabled={
                                  house && house.booking_status === "Booked"
                                    ? true
                                    : false
                                }
                              />
                              <div className="Neon-input-dragDrop">
                                <div className="Neon-input-inner">
                                  <div className="Neon-input-icon">
                                    <img src={OwnerPlusSvg} />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {houseDocImages?.length > 0 &&
                              houseDocImages?.map((value, i) => (
                                <div key={i + "_docs"} className="owner_img">
                                  <div
                                    className="close_icon"
                                    onClick={() =>
                                      !(house &&
                                        house.booking_status === "Booked"
                                        ? true
                                        : false) && removeDoc(i)
                                    }
                                  >
                                    <img
                                      src={CloseCircleSvg}
                                      alt="close-circle`"
                                    />
                                  </div>
                                  <img
                                    style={{ width: "50px", height: "50px" }}
                                    src={
                                      getSafeUrl(value?.imageUrl)
                                    }
                                    alt={value?.name}
                                    onError={(e) => {
                                      e.target.src = UploadImg;
                                    }}
                                  />
                                </div>
                              ))}
                            {inputError && houseDocImages?.length <= 0 && (
                              <div className="sap-val-error text-danger mb-0 mt-2 ms-3">
                                Please upload your property files!
                              </div>
                            )}
                          </div>

                          <hr className="mt-3 p-1"></hr>
                          <h4>
                            Are utilities included in the house price? &nbsp;
                            <label style={{ margin: "20px" }}>
                              <input
                                type="radio"
                                className="me-2"
                                name="utilities_price_included"
                                value={isUtilityIncludedPrice}
                                checked={isUtilityIncludedPrice === true}
                                onChange={handleRadioChange}
                                disabled={
                                  house && house.booking_status === "Booked"
                                }
                              />
                              Yes
                            </label>
                            <label>
                              <input
                                type="radio"
                                name="utilities_price_included"
                                value={isUtilityIncludedPrice}
                                className="me-2"
                                checked={isUtilityIncludedPrice === false}
                                onChange={handleRadioChange}
                                disabled={
                                  house && house.booking_status === "Booked"
                                }
                              />
                              No
                            </label>
                          </h4>
                          <label
                            htmlFor="propertyDetail"
                            className="mb-1 new_house_field"
                          >
                            Utilities
                          </label>

                          <div className="check_amenit check_amenit_two">
                            {utilityData.map((ele) => (
                              <div className="form-check" key={ele.id}>
                                <label
                                  className="form-check-label"
                                  htmlFor={ele.id}
                                >
                                  {ele.name}
                                </label>

                                {/* <div>
                                  <Input
                                    type="text"
                                    id="premiumPrice"
                                    addonBefore="$"
                                    placeholder="Price"
                                    value={
                                      houseUtility.find(
                                        (item) => item.name === ele.name
                                      )?.price || ""
                                    }
                                    addonAfter="/month"
                                    onKeyPress={(e) => {
                                      if (
                                        !/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) =>
                                      handlePriceChange(ele, e.target.value)
                                    }
                                    style={{ width: "150px" }}
                                    disabled={isDisabled}
                                  />
                                  {error && !ele.price && (
                                    <div className="sap-val-error text-danger mb-0 mt-1">
                                      Please enter price!
                                    </div>
                                  )}
                                </div> */}
                              </div>
                            ))}

                            {/* {inputError && houseUtility?.length === 0 && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please select utility
                              </div>
                            )} */}
                          </div>

                          <div className="check_amenit">
                            {/* {utilityData.map((ele, i) => (
                              <div className="form-check" key={ele.id}>
                                <input
                                  id={ele.id}
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={houseUtility.some(
                                    (item) => item.name === ele.name
                                  )}
                                  onChange={() => handleCheckboxUtility(ele)}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={ele.id}
                                >
                                  {ele.name}
                                </label> */}

                            {/* <div>
                                  <Input
                                    type="text"
                                    id="premiumPrice"
                                    addonBefore="$"
                                    placeholder="Price"
                                    value={
                                      houseUtility.find(
                                        (item) => item.name === ele.name
                                      )?.price || ""
                                    }
                                    addonAfter="/month"
                                    onKeyPress={(e) => {
                                      if (
                                        !/(?:^| )\d+(\.\d+)?(?=$| )/.test(e.key)
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                    onChange={(e) =>
                                      handlePriceChange(ele, e.target.value)
                                    }
                                    style={{ width: "150px" }}
                                    disabled={isDisabled}
                                  />
                                  {error && !ele.price && (
                                    <div className="sap-val-error text-danger mb-0 mt-1">
                                      Please enter price!
                                    </div>
                                  )}
                                </div> */}
                          </div>
                          {/* ))}

                            {inputError && houseUtility?.length === 0 && (
                              <div className="sap-val-error text-danger mb-0 mt-1">
                                Please select utility
                              </div>
                            )}
                          </div> */}
                          <div className="col-lg-3 col-md-6">
                            <div className="mb-3 new_house_field">
                              <label
                                htmlFor="monthlyPrice"
                                className="form-label"
                              >
                                Enter Utility Total Price
                                <Tooltip
                                  title="Please sum up all the amounts of utilities wherever applicable and indicate the aggregated amount in the Utility Amount field !"
                                  style={{ width: "20px" }}
                                >
                                  {" "}
                                  <i className="fa-solid fa-circle-info"></i>
                                </Tooltip>
                              </label>

                              {/* <input
                                type="tel"
                                className="form-control"
                                id="monthlyPrice"
                                placeholder="Enter Utility Total  Price"
                                name="total_utilities_price"
                                disabled={isUtilityIncludedPrice}
                                value={utilityPrice}
                                onChange={(e) =>
                                  setUtilityPrice(e.target.value)
                                }
                              /> */}

                              <InputNumber
                                // className="form-control"
                                min={0}
                                max={100000000}
                                // style={{width:"100%"}}
                                prefix="$"
                                //  addonAfter="/month"
                                placeholder="Enter Utility Total  Price"
                                name="total_utilities_price"
                                disabled={isUtilityIncludedPrice}
                                value={utilityPrice}
                                onChange={(value) => {
                                  setUtilityPrice(value);
                                }}
                              />

                              {!isUtilityIncludedPrice &&
                                inputError &&
                                !utilityPrice > 0 && (
                                  <div className="sap-val-error text-danger mb-0 mt-1">
                                    Please Enter Price
                                  </div>
                                )}
                            </div>
                          </div>

                          {/* pet allowed */}

                          <div>
                            <h4
                              className="mr-5"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              Pets Allowed : {"   "}
                              <div className="d-flex align-items-center ml-5 ms-2">
                                <div className="form-check form-check-inline me-2 ">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_pets_allowed"
                                    value="yes"
                                    checked={petAllowed === true}
                                    onChange={handleAnimalAllowed}
                                    disabled={
                                      house && house.booking_status === "Booked"
                                    }
                                  />
                                  <label className="form-check-label">
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check form-check-inline me-2">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="is_pets_allowed"
                                    value="no"
                                    checked={petAllowed === false}
                                    onChange={handleAnimalAllowed}
                                  />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                            </h4>
                          </div>

                          <h4>Add Amenities and Overview</h4>
                          <div className="check_amenit">
                            {amenitiesData &&
                              amenitiesData?.map((ele, i) => {
                                return (
                                  <div className="form-check" key={i}>
                                    <input
                                      id={ele}
                                      className="form-check-input"
                                      type="checkbox"
                                      checked={houseAmenities?.includes(ele)}
                                      onChange={() => handleCheckboxChange(ele)}
                                      disabled={
                                        house &&
                                          house.booking_status === "Booked"
                                          ? true
                                          : false
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={ele}
                                    >
                                      {ele}
                                    </label>
                                  </div>
                                );
                              })}
                          </div>
                          <div className="br_btn amenit">
                            <button
                              onClick={handleConfirmForSubmit}
                              type="button"
                              disabled={btnLoader}
                              hidden={
                                house && house.booking_status === "Booked"
                                  ? true
                                  : false
                              }
                            >
                              Save Details
                              {btnLoader && <Spinner />}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={iSubmitConfirmation}
        // onOk={handleSubmit}
        onCancel={() => setIsSubmitConfirmation(false)}
        footer={null}
        title={
          <span style={{ fontSize: "20px", fontWeight: "bold" }}>
            Restricted Words Detected
          </span>
        }
      >
        <p>
          Your submission included restricted words (like addresses, emails, or
          phone numbers). To proceed, we updated the house name for you
        </p>
        <p>
          <strong>Updated Property Name:</strong>{" "}
          {makeValidHousename(inputData?.propertyName) ||
            inputData?.propertyName}
        </p>
        <p>
          <strong>Updated Property detail:</strong>{" "}
          {makeValidHouseDescription(inputData?.propertyDetail) ||
            inputData?.propertyDetail}
        </p>
        <div className="modal-footer" style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            onClick={() => {
              house ? handleUpdateSubmit() : handleSubmit();
            }}
            style={{ marginRight: "8px" }}
          >
            Proceed with Updated Name
          </Button>
          <Button onClick={() => setIsSubmitConfirmation(false)}>
            Edit Name Again
          </Button>
        </div>
      </Modal>
    </main>
  );
}

export default OwnerAddHouse;
